export default {
  SET_FRETES(state, fretes) {
    state.fretes = Array.isArray(fretes) ? fretes : [];
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
  SET_DASHBOARD_FRETES(state, payload) {
    if (payload.totalNF) {
      state.totalNumFretes = payload.totalNumFretes;
      state.totalNF = (payload.totalNF).toFixed(2);
      state.pesoTotal = (payload.totalPeso).toFixed(2);
      state.totalFretes = (payload.totalFrete).toFixed(2);
      state.mediaKG = (payload.totalKGMedia).toFixed(2);
    } else {
      state.dentroPrazo = payload.dentroPrazo;
      state.foraPrazo = payload.foraPrazo;
      state.totalFechados = payload.totalFechados;
      state.totalPendentes = payload.totalPendentes;
    }
  },
  RESET_DASHBOARD_FRETES(state) {
    state.totalNumFretes = 0;
    state.totalNF = 0;
    state.pesoTotal = 0;
    state.totalFretes = 0;
    state.mediaKG = 0;
  },
  SET_ANALISE_HEADERS(state, headers) {
    state.analiseHeaders = headers;
  },
};
